export default __webpack_public_path__ + "static/media/podolsk_products.227c4a84.jpg";